import React from 'react';
import { Col, FormControl, FormGroup, Panel, Row } from 'react-bootstrap';
// src
import AnagraficaCliente from './AnagraficaCliente.js';
import IndirizzoCliente from './IndirizzoCliente.js';
import ContattiCliente from './ContattiCliente.js';
import NuovoCliente from './NuovoCliente.js';
// css
import '../../../styles/commonStyles.css';

class PanelCliente extends React.Component {
	constructor(props) {
		super(props);

    this.state = {
      editMode: (this.props.editMode)? true : null
    };	

		this.validateOnChange = this.validateOnChange.bind(this);
	}

  render() {
  	const { panCliente, panIndirizzo, panNuovoCliente, editMode } = this.props;

  	return (
      <React.Fragment>
      <Col xs={12}>
        <Panel>
          <Panel.Heading>Cliente</Panel.Heading>
          <Panel.Body>
            <NuovoCliente panNuovoCliente={panNuovoCliente} editMode={editMode} />
            <AnagraficaCliente panCliente={panCliente} editMode={editMode} />
            <ContattiCliente panCliente={panCliente} editMode={editMode}
              needsTwoContacts={this.props.needsTwoContacts} />
            <IndirizzoCliente panIndirizzo={panIndirizzo} editMode={editMode} />
          </Panel.Body>
        </Panel>
      </Col>
      </React.Fragment>
  	);
  }  

  /*
  <PanelIndirizzo title="Indirizzo del cliente" 
        via="via2" cap="cap2" provincia="provincia2" localita="localita2"
        cVia="Via (cliente)" cCap="CAP (cliente)" cProvincia="Provincia (cliente)" cLocalita="Località (cliente)"
        panIndirizzo={panIndirizzo} editMode={editMode}
      />
  */

  // Gestisce il mancato superamento della validazione
  handleInvalidField(field, errorMessage) {    
    // invalida il form (non permette il submit)
    field.setCustomValidity(errorMessage); 
    // cambia il colore dei bordi del campo
    field.classList.add('invalid-field'); 
    // mostra il messaggio di warning a video
    this.setState({[field.name] : [errorMessage]}); 
  }

  // Gestisce il superamento della validazione
  handleValidField(field) {
    let style = 'invalid-field';
    // Invalida il form (non permette il submit)
    field.setCustomValidity(''); 
    // Cambia il colore dei bordi del campo    
    if(field.classList.contains(style))
      field.classList.remove(style); 
    // Pulisce il messaggio di warning a video
    this.setState({[field.name] : ''});  
  }

  // Valida il campo e richiama il feedback appropriato
  validateOnChange(e) {        
    const field = e.target;
    const pattern = e.target.pattern;               
    const message = this.generateMessage(field.name);   
    
    field.value = field.value.toUpperCase();

		if(!field.value.match(pattern)) {			
			this.handleInvalidField(field, message);
		} else {
      this.handleValidField(field);
    }
  }

  // Ritorna un messaggio di errore in base al NOME del campo
  // che non ha superato la validazione del formato
  generateMessage(fieldName) {
    switch(fieldName) {
      case "capCliente": 
        return '5 numeri';        
      case "provinciaCliente": 
        return '2 lettere'; 
       case "cf": 
        return "16 caratteri alfa"   
      default:
        return null;
    }
  }

}

export default PanelCliente;


// WEBPACK FOOTER //
// ./src/cmp/Orders/Panels/PanelCliente/PanelCliente.js